import React from 'react';
import clsx from 'clsx';
// Default loading
const DefaultLoading: React.FC = () => {
  return (
    <div className={clsx('jarvis-ScrollView__DefaultLoading')}>
      <div className="jarvis-ScrollView__DefaultLoading--spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default DefaultLoading;
